<template>
  <div class="pie">
      <span class="type">用户使用工具类型统计</span>
      <!-- 雷达图 -->
      <div :id="id" style="height:350px;width:100%"></div>
  </div>
</template>
<script>
import {statisticsAPI } from 'liankong-ui-api'
import * as echarts from 'echarts'
export default {
  props:{
      id:{
          type:String,
          default:'myCharts'
      },
      title:{
          type:String,
          default:''
      }
  },
  data(){
      return {
          
      }
  },
  mounted(){
      // this.getList()
      
  },
  methods:{
      getList(startDay,endDay){
          statisticsAPI.statisByType({
              endDay,startDay
          }).then(res=>{
              if(res.code==0){
              var mCharts = echarts.init(document.getElementById(this.id))
              const data = res.data.map(item=>{
                return {
                  value:item.useCount,
                  name:item.toolTypeName
                }
              })
              let option = {
                  tooltip: {
                    trigger: 'item'
                  },
                  legend: {
                    top: 'center',
                    right: '3%',
                    orient: 'vertical',
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  color:['#91cc75','#fac858','#fc8452','#73c0de','#fc8452','#3ba272','#6183eb','#fac858','#5470c6'],
                  series: [
                    {
                      // name: 'Access From',
                      type: 'pie',
                      itemStyle: {
                        borderRadius: 25,
                        borderColor: '#070a17',
                        borderWidth: 2
                      },
                      left:0,
                      label: {
                        show: false,
                        position: 'center',
                      },
                      tooltip: { formatter: '{b} {c} 次' } ,
                      labelLine: {
                        show: false
                      },
                      data,
                    }
                  ]
                };
                  mCharts.setOption(option)
              } else {
                  this.$message.error(res.message)
              }
              
              // console
          })
      }
  }
}
</script>
<style lang="less" scoped>
.pie {
  position: relative;
  .type {
    position: absolute;
    top: 10px;
    margin: 10px 25px;
    box-sizing: border-box;
    font-size: 15px;
    color: #06f1ef;
    font-weight: bold;
  }
}
</style>

